import styled from 'styled-components';

export const ResourcesPageContainer = styled.div`
  background-color: #d4af37;
  color: #000000;
`;

export const Section = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
`;

export const SectionTitle = styled.h2`
  margin: 0 0 16px;
  font-size: 1.6rem;
`;

export const MediaGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const MediaCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 0.9rem;
`;

export const MediaTitle = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
`;

export const MediaMeta = styled.div`
  font-size: 0.8rem;
  color: #555555;
  margin-bottom: 6px;
`;

export const MediaPlayerWrapper = styled.div`
  margin-top: 8px;
`;
